import { render } from "./SortArrow.vue?vue&type=template&id=799842e2&scoped=true"
import script from "./SortArrow.vue?vue&type=script&lang=js"
export * from "./SortArrow.vue?vue&type=script&lang=js"

import "./SortArrow.vue?vue&type=style&index=0&id=799842e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799842e2"]])

export default __exports__